export const environment = {
  production: false,
  apiUrl: 'https://testapi.oreincloud.it',
  isTest: true,
  isDemo: false,
  enableBugsnag: true,
};
